import { LobbyService } from './../_services/lobby.service';
import { Component, OnInit, Inject, OnDestroy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';
import { MAT_DIALOG_DATA } from '@angular/material';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-lobby-filters',
  templateUrl: './lobby-filters.component.html',
  styleUrls: ['./lobby-filters.component.scss']
})
export class LobbyFiltersComponent implements OnInit, OnDestroy {
  sub_isMobileScreen: Subscription;
  games = [];
  filters = null;
  isMobile = false;
  minEntrants = 0;
  maxEntrants = 200000;
  minBuyin = 0;
  maxBuyin = 10000;
  user_id = null;
  search = '';
  contests = ['tiers','rankem','bestball','snake','gpp','multi','playoffs'];
  color = 'warn';
  checked = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) private data,
    public dialogRef: MatDialogRef<LobbyFiltersComponent>,
    private _lobbyService: LobbyService,
    private store: Store<any>) {
      this.sub_isMobileScreen = this.store.select('isMobileScreen').subscribe(state => {
        if (state.length > 0) {
          this.isMobile = state[0];
        }
      });
      this._lobbyService.getGames().subscribe(res=>{
        if (res.status == 'success'){
          this.games = res.entities;
        }
      });
      this.filters = data.filters;
      this.user_id = data.user_id;

      this.setDefaults();
    }

  ngOnInit() {
  }

  ngOnDestroy() {
    this.sub_isMobileScreen.unsubscribe();
  }

  setDefaults(){
    if (this.filters.entrant != null){
      this.minEntrants = this.filters.entrant.split(';')[0];
      this.maxEntrants = this.filters.entrant.split(';')[1];
      if (this.maxEntrants == 10000) {
        this.maxEntrants = 200000;
      }
    }
    if (this.filters.buyin != null){
      this.minBuyin = this.filters.buyin.split(';')[0];
      this.maxBuyin = this.filters.buyin.split(';')[1];
    }
    if (this.filters.name != null){
      this.search = this.filters.name;
    }
    if (this.filters.contests != null){
      this.contests = this.filters.contests.split(',');
    }
    
    if (this.filters.use == 'true'){
      this.checked = true;
    }
    else {
      this.checked = false;
    }
  }

  resetFilters(){
    //event.target.disabled = true;
    this.filters = {
      'apply_lobby_filter':'0',
      'buy_in_orderby':'DESC',
      'buyin':'0;10000',
      'entrant':'0;10000',
      'entrant_orderby':'DESC',
      'game_id':'all',
      'name':'',
      'orderby':'',
      'sortkey':'',
      'use':'false',
      'contests':'tiers,rankem,bestball,snake,gpp,multi,playoffs'
    };
    //call service to store to db
    this._lobbyService.storeFilters(this.filters, this.user_id).subscribe(state=>{
      this.dialogRef.close(this.filters);
    });
  }

  saveFilters(){
    //event.stopPropagation();
    //event.target.disabled = true;
    this.filters.use = 'true';
    this.filters.apply_lobby_filter = 1;
    this.filters.entrant = this.minEntrants.toString()+';'+this.maxEntrants.toString();
    this.filters.buyin = this.minBuyin.toString()+';'+this.maxBuyin.toString();
    this.filters.name = this.search;
    this.filters.contests = this.contests.join(',');
    this._lobbyService.storeFilters(this.filters, this.user_id).subscribe(state=>{
      this.dialogRef.close(this.filters);
    });
  }

  selectSport(game){
    let newGames = [];
    if (this.filters.game_id != null && (this.filters.game_id.split(',').indexOf('all') > -1 || this.filters.game_id.split(',').indexOf(game) > -1)){
      //build new game_id without game
      this.games.forEach(g=>{
        if (g.id != game && (this.filters.game_id.split(',').indexOf(g.id) > -1 || this.filters.game_id.split(',').indexOf('all') > -1)) newGames.push(g.id);
      });
      this.filters.game_id = newGames.join(',');
    } else if (this.filters.game_id != null && this.filters.game_id.split(',').indexOf(game) == -1){
      //append game to sports
      if (this.filters.game_id.length) this.filters.game_id += ',';
      this.filters.game_id += game;
      if (this.filters.game_id.split(',').length == this.games.length) this.filters.game_id = 'all';
    } else if (this.filters.game_id == null){
      //build all
      this.filters.game_id = 'all';
    }
  }

  setContest(item,event){
    if (event.checked && this.contests.indexOf(item) == -1) this.contests.push(item);
    if (!event.checked && this.contests.indexOf(item) > -1) this.contests = this.contests.filter(c => c!=item);
  }
  
  changed() {
    if (!this.checked) {
      this.resetFilters();
    }
  }
}
